import { useEffect, useState } from "react";

import fetchPayment from "@/hooks/magnolia/fetch-payment";
import { PaymentMagnoliaDataType } from "@/types/payment-types";

export const useGetPaymentTitle = () => {
  const [paymentData, setPaymentData] = useState<
    PaymentMagnoliaDataType | undefined
  >(undefined);

  useEffect(() => {
    Promise.resolve(fetchPayment())

      .then((res: PaymentMagnoliaDataType | undefined) => {
        setPaymentData(res);
      })
      .catch((e) => {
        throw e;
      });
  }, []);
  return paymentData;
};
